import Layout2 from '@/layout/Layout2'
let ja = require('../../common/lang/ja')
let zh = require('../../common/lang/zh-CN')

export default [{
  path: '/shopRoom',
  component: Layout2,
  meta: {
    zhtitle: zh.m.aside.nav.ROOM,
    jatitle: ja.m.aside.nav.ROOM
  },
  children: [{
    path: '',
    name: 'list',
    component: () => import( /* webpackChunkName: "jp.shopRoom" */ '@/merchanAdmin/room/list'),
    meta: {
      zhtitle: zh.m.aside.nav.ROOM,
      jatitle: ja.m.aside.nav.ROOM,
      pername: "shop_compartment"
    },
  }, {
    path: 'create',
    name: 'shopRoomcreate',
    component: () => import( /* webpackChunkName: "jp.shopRoom" */ '@/merchanAdmin/room/detail'),
    meta: {
      zhtitle: zh.m.router.common.CREATE,
      jatitle: ja.m.router.common.CREATE,
      pername: "shop_compartment"
    },
  }, {
    path: 'detail',
    name: 'shopRoomdetail',
    component: () => import( /* webpackChunkName: "jp.shopRoom" */ '@/merchanAdmin/room/detail'),
    meta: {
      zhtitle: zh.m.router.common.EDIT,
      jatitle: ja.m.router.common.EDIT,
      pername: "shop_compartment"
    },
  }, {
    path: 'time',
    name: 'shopRoomtime',
    component: () => import( /* webpackChunkName: "jp.shopRoom" */ '@/merchanAdmin/room/time'),
    meta: {
      zhtitle: zh.m.aside.nav.TIME,
      jatitle: ja.m.aside.nav.TIME,
      pername: "shop_compartment"
    },
  }]
}]
